import { render, staticRenderFns } from "./withdraw_address.vue?vue&type=template&id=16b452ed&scoped=true&"
import script from "./withdraw_address.vue?vue&type=script&lang=js&"
export * from "./withdraw_address.vue?vue&type=script&lang=js&"
import style0 from "./withdraw_address.vue?vue&type=style&index=0&id=16b452ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b452ed",
  null
  
)

export default component.exports